import { render, staticRenderFns } from "./PscCompanyInstruction.vue?vue&type=template&id=684a7cf8&scoped=true&"
import script from "./PscCompanyInstruction.vue?vue&type=script&lang=js&"
export * from "./PscCompanyInstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684a7cf8",
  null
  
)

export default component.exports